import React, { useContext, useEffect, useState } from "react";
import "./InviteProject.css";
import { useLanguage } from "../../../../LanguageProvider";
import Chip from "../../../../components/Chip/Chip";
import { TbSend } from "react-icons/tb";
import Dropdown from "../../../../components/Dropdown/Dropdown";
import { GeneralContext } from "../../../../GeneralProvider";
import { useToaster } from "../../../../ToasterProvider";
import Services from "../../../../services/Services";

export default function InviteProject({ collaborators, selectedProjectID }) {
  const { toastWarning, toastSuccess, toastError } = useToaster();
  const { getTranslation } = useLanguage();
  const { handleInviteToProject, fetchMembers, userId, useToken } =
    useContext(GeneralContext);
  const [selectedCollaborator, setSelectedCollaborator] = useState(null);
  const [addedCollaborators, setAddedCollaborators] = useState([]);
  const [selectedAuthorization, setSelectedAuthorization] = useState(null);
  const [collectionIDs, setCollectionIDs] = useState([]);
  const [panelIDs, setPanelIDs] = useState([]);

  const handleSendInvitation = () => {
    if (!selectedAuthorization) {
      toastWarning(getTranslation("pleaseSelectAuthorization"));
      return;
    }

    for (let i = 0; i < addedCollaborators.length; i++) {
      let auth;
      if (selectedAuthorization === "employee") {
        auth = {
          type: "employee",
          authorizations: {
            collections:
              collectionIDs.length > 0
                ? collectionIDs.map((id) => ({ id, authorization: "read" }))
                : [],
            panels:
              panelIDs.length > 0
                ? panelIDs.map((id) => ({ id, authorization: "read" }))
                : [],
          },
        };
      } else if (selectedAuthorization === "partner") {
        auth = {
          type: "partner",
          authorizations: "all",
        };
      } else if (selectedAuthorization === "owner") {
        auth = {
          type: "owner",
          authorizations: "all",
          canSeeKronos: true,
        };
      }

      handleInviteToProject(
        addedCollaborators[i].memberID,
        selectedProjectID,
        auth
      )
        .then((res) => {
          if (res) {
            setAddedCollaborators([]);
            setSelectedCollaborator(null);
            fetchMembers();
            toastSuccess(getTranslation("successMessage"));
          } else {
            toastError(getTranslation("somethingWentWrong"));
          }
        })
        .catch((err) => {
          console.error("Error during invitation:", err);
          toastError(getTranslation("somethingWentWrong"));
        });
    }
  };

  // Collection ve panel ID'lerini çekiyoruz
  const fetchIDs = async () => {
    try {
      const response = await Services.GetCollectionAndPanelIDs(
        useToken,
        selectedProjectID
      );
      if (response.data.status) {
        setCollectionIDs(response.data.result.collections.map((x) => x.id));
        setPanelIDs(response.data.result.panels.map((x) => x.id));
      } else {
        setCollectionIDs([]);
        setPanelIDs([]);
      }
    } catch (error) {
      console.log(error);
      setCollectionIDs([]);
      setPanelIDs([]);
    }
  };

  useEffect(() => {
    fetchIDs();
  }, [selectedProjectID]);

  const dropdownOptions = collaborators?.map((collaborator) => ({
    value: collaborator.memberID,
    label: `${collaborator.name} ${collaborator.lastname}`,
  }));

  const handleAddCollaborator = () => {
    if (
      selectedCollaborator &&
      !addedCollaborators.some(
        (collaborator) =>
          collaborator.memberID === selectedCollaborator.memberID
      )
    ) {
      setAddedCollaborators([...addedCollaborators, selectedCollaborator]);
      setSelectedCollaborator(null);
    }
  };

  const handleRemoveCollaborator = (memberID) => {
    setAddedCollaborators(
      addedCollaborators.filter(
        (collaborator) => collaborator.memberID !== memberID
      )
    );
  };

  return (
    <div className="invite-panel">
      <p className="invite-collaborators-title">
        {getTranslation("inviteCollaborators")}
      </p>

      <div className="invite-collaborators">
        <Dropdown
          style={{ marginRight: "2px", width: "100%" }}
          options={dropdownOptions.filter((user) => user.value !== userId)}
          placeholder={getTranslation("selectFromList")}
          onChange={(e) => {
            const selected = collaborators.find(
              (collaborator) => collaborator.memberID === e.target.value
            );
            setSelectedCollaborator(selected);
          }}
          value={selectedCollaborator?.memberID || ""}
          isDisabled={!collaborators || collaborators.length === 0}
        />

        <button
          onClick={handleAddCollaborator}
          disabled={!collaborators || collaborators.length === 0}
        >
          {getTranslation("add")}
        </button>
      </div>

      <div className="collaborators-chips">
        {addedCollaborators.map((collaborator, index) => (
          <Chip
            onDeleteClicked={() =>
              handleRemoveCollaborator(collaborator.memberID)
            }
            label={`${collaborator.name} ${collaborator.lastname}`}
            key={index}
          />
        ))}
      </div>

      {addedCollaborators.length > 0 && (
        <div
          style={{
            width: "100%",
            flexDirection: "row",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button onClick={handleSendInvitation} className="send-invite-button">
            <TbSend strokeWidth={1} /> {getTranslation("sendInvitation")}
          </button>
        </div>
      )}

      <div className="authorizations">
        <p className="invite-collaborators-subtitle">
          {getTranslation("authorizations")}
        </p>
        <div className="radio-options">
          <label className="invite-collaborators-text">
            <input
              type="radio"
              name="authorization"
              value="employee"
              onChange={(e) => setSelectedAuthorization(e.target.value)}
            />
            {getTranslation("employee")}
          </label>
          <label className="invite-collaborators-text">
            <input
              type="radio"
              name="authorization"
              value="partner"
              onChange={(e) => setSelectedAuthorization(e.target.value)}
            />
            {getTranslation("partner")}
          </label>
          <label className="invite-collaborators-text">
            <input
              type="radio"
              name="authorization"
              value="owner"
              onChange={(e) => setSelectedAuthorization(e.target.value)}
            />
            {getTranslation("owner")}
          </label>
        </div>
      </div>
    </div>
  );
}
